import httpClient from '@/common/http'

export default {
  create(obj) {
    return httpClient.request('post', 'settings/roles', obj);
  },

  update(id, obj) {
    return httpClient.request('put', `settings/roles/${id}`, obj);
  },

  delete(id) {
    return httpClient.request('delete', `settings/roles/${id}`);
  },

  findAll(filter, sort, paginate = {skip: 0, limit: -1}) {
    let query = `${sort}`
    query += (paginate.limit < 1) ? '' : `&skip=${paginate.skip}&limit=${paginate.limit}`
    return httpClient.request('get', `settings/roles?${filter}${query}`)
  }

}